module.exports = __webpack_public_path__ + "img/甄利凯.18bf0e88.jpg";